/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UserDto = {
    readonly salutation?: UserDto.salutation;
    readonly firstName?: string;
    readonly lastName?: string;
    readonly phoneNumber?: string;
    readonly email?: string;
};
export namespace UserDto {
    export enum salutation {
        MR = 'MR',
        MRS = 'MRS',
        OTHER = 'OTHER',
    }
}

